import FramedImage from '../pixi/FramedImage';

let PIXI;
if (typeof window !== 'undefined') {
  PIXI = require('pixi.js');
}

class Slide {
  constructor(imgSrc, index, app, callback, focalX = 0.5, focalY = 0.5) {
    console.log(imgSrc);
    this.index = index;
    this.container = new PIXI.Container();
    this.app = app;
    this.framedImage = new FramedImage(app, imgSrc, false, focalX, focalY, 0.5);
    this.framedImage.load().then(() => {
      this.container.addChild(
        this.framedImage.mask,
        this.framedImage.imgContainer
      );
      this.framedImage.setVisible(true);
      if (callback) {
        callback();
      }
    });
    this.container.visible = false;
  }
  getContainer() {
    return this.container;
  }
  setVisible(bool = true) {
    this.container.visible = bool;
  }
  getDimensions(size) {
    const containerWidth = this.app.renderer.width;
    const containerHeight = this.app.renderer.height;
    switch (size) {
      case 'left':
        return {
          width: containerWidth * 0.27,
          height: containerHeight,
          x: 0,
          y: 0,
        };
      case 'right':
        return {
          width: containerWidth * 0.27,
          height: containerHeight,
          x: containerWidth * 0.73,
          y: 0,
        };
      case 'closeLeft':
        return {
          width: 0,
          height: containerHeight,
          x: containerWidth * 0.27,
          y: 0,
        };
      case 'closeRight':
        return {
          width: 0,
          height: containerHeight,
          x: containerWidth * 0.73,
          y: 0,
        };
      case 'center':
        return {
          width: containerWidth * 0.46,
          height: containerHeight,
          x: containerWidth * 0.27,
          y: 0,
        };
      case 'halfLeft':
        return {
          width: containerWidth / 2,
          height: containerHeight,
          x: 0,
          y: 0,
        };
      case 'halfRight':
        return {
          width: containerWidth / 2,
          height: containerHeight,
          x: containerWidth / 2,
          y: 0,
        };
      case 'offLeft':
        return {
          width: 0,
          height: containerHeight,
          x: 0,
          y: 0,
        };
      case 'offRight':
        return {
          width: 0,
          height: containerHeight,
          x: containerWidth,
          y: 0,
        };
      case 'full':
      default:
        return {
          width: containerWidth,
          height: containerHeight,
          x: 0,
          y: 0,
        };
    }
  }
  getScreenAlpha(size, darken = false) {
    let screenAlpha = 0.82;
    if (
      size === 'center' ||
      size === 'halfLeft' ||
      size === 'halfRight' ||
      size === 'full'
    ) {
      screenAlpha = 0.52;
    }
    if (darken) {
      screenAlpha += 0.11;
    }
    return screenAlpha;
  }
  draw(size, screenAlign = true, darken = false) {
    this.framedImage.setImageSize(
      this.getDimensions(size),
      screenAlign,
      this.getScreenAlpha(size, darken)
    );
    this.setVisible();
  }
  move(size, alpha, screenAlign = true, darken = false, duration = 1) {
    this.framedImage.panToCoverSize(
      this.getDimensions(size),
      duration,
      null,
      screenAlign,
      typeof alpha === 'undefined' || alpha === 'default'
        ? this.getScreenAlpha(size, darken)
        : alpha
    );
  }
  enterFromRight(screenAlign = true) {
    if (this.isOff) {
      this.framedImage.setImageSize(
        this.getDimensions('offRight'),
        screenAlign,
        this.getScreenAlpha('right')
      );
    }
    this.setVisible();
    this.isOff = false;
    this.framedImage.panToCoverSize(
      this.getDimensions('right'),
      1,
      null,
      screenAlign,
      this.getScreenAlpha('right')
    );
  }
  enterFromLeft(screenAlign = true) {
    if (this.isOff) {
      this.framedImage.setImageSize(
        this.getDimensions('offLeft'),
        screenAlign,
        this.getScreenAlpha('left')
      );
    }
    this.setVisible();
    this.isOff = false;

    this.setVisible();
    this.framedImage.panToCoverSize(
      this.getDimensions('left'),
      1,
      null,
      screenAlign,
      this.getScreenAlpha('left')
    );
  }
  off() {
    this.setVisible(false);
    this.isOff = true;
  }
}

export default Slide;



// WEBPACK FOOTER //
// ./src/components/PixiPressPlay/Slide.js